var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 46 46",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1034 35.3328C11.7001 35.3321 11.3157 35.1621 11.0439 34.8642C10.7671 34.5687 10.6296 34.1692 10.6659 33.7659L11.0181 29.8933L27.2877 13.6294L32.3721 18.7124L16.1068 34.9749L12.2342 35.3271C12.1896 35.3314 12.1451 35.3328 12.1034 35.3328ZM33.387 17.6961L28.304 12.6131L31.3529 9.56418C31.6226 9.29425 31.9884 9.14258 32.37 9.14258C32.7515 9.14258 33.1174 9.29425 33.387 9.56418L36.4359 12.6131C36.7059 12.8827 36.8575 13.2486 36.8575 13.6301C36.8575 14.0117 36.7059 14.3775 36.4359 14.6472L33.3884 17.6947L33.387 17.6961Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.0a811a65.svg";
export { ForwardRef as ReactComponent };